<div
  #coolingGraph
  [style.width]="width"
  [style.height]="height"
  class="cooling-graph-container"
></div>
